<div class="tag-result">
  <div class="tag-result__toolbar">
    <ui-search
      [placeholder]="'DATABASE_TAGS.PLACEHOLDERS.SEARCH' | translate"
      [searchQuery]="searchQuery()"
      (onInput)="onSearchQuery($event)"
    ></ui-search>
    <ui-button
      type="primary"
      [text]="'DATABASE_TAGS.BUTTONS.CREATE' | translate"
      (clickAction)="openCreateDialog()"
    ></ui-button>
  </div>

  @if (!tags().length) {
    <ui-no-data [imgSrc]="noData.imgSrc" [title]="noData.title | translate"></ui-no-data>
  } @else if (!filteredTags().length) {
    <ui-no-data [imgSrc]="noResults.imgSrc" [title]="noResults.title | translate"></ui-no-data>
  } @else {
    @if (tableConfig(); as config) {
      <div class="tag-result__table">
        <ui-dataset-table
          [data]="filteredTags()"
          [config]="config"
          (rowAction)="onRowAction($event)"
        ></ui-dataset-table>
      </div>
    }
  }

  <!-- CELL TEMPLATES -->
  <ng-template #nameCell let-row>
    <div class="tag-name">
      <div class="tag-name__color" [style.background-color]="row.color || defaultTagColor"></div>
      <div class="tag-name__text">{{ row.name }}</div>
    </div>
  </ng-template>

  <ng-template #isShownInLeftPanelCell let-row>
    @if (isShownInLeftPanel(row)) {
      <span class="ui-icon-checkmark"></span>
    } @else {
      <span class="ui-icon-close"></span>
    }
  </ng-template>
</div>
